var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"pg-check",class:{ checked: _vm.value },on:{"click":function($event){$event.stopPropagation();return _vm.$emit('input', !_vm.value)}}},[_c('span',{staticClass:"checkbox-inner",class:{ transparent: _vm.transparent }})])
}
var staticRenderFns = []

export { render, staticRenderFns }